import { useMutation } from '@tanstack/react-query'
import { initiateCustomersRewardsDistribution } from 'services/RewardsService'
import { BaseErrorResponse } from 'types/beneficiaries'
import { type DistributionRequest } from 'types/rewards'

export const useInitiateCustomersRewardsWithdrawalMutation = () =>
  useMutation<void, BaseErrorResponse, DistributionRequest>({
    mutationFn: initiateCustomersRewardsDistribution,
  })
